import React from "react";
import CardDetail from "../components/CardDetail";

function DetailPage() {
  return (
    <div>
      <CardDetail />
    </div>
  );
}

export default DetailPage;
